import React, { Component } from 'react'
import News from '../components/News'
import Footer from '../components/Common/Footer'
import { isAdmin } from '../util/service'

export default class NewsContainer extends Component {
    componentDidMount() {
        // temp
        if (!isAdmin()) {
            window.open('/', '_self')
        }
    }

    render() {
        return (
            <>
                <News />
                <Footer />
            </>
        )
    }
}
